import type { Moment } from "moment/moment";
import type { KubernetesLiveResourceStatusCode } from "./kubernetesLiveResourceStatusCode";
export type BaseKubernetesLiveStatusDetailedResource = {
    Name: string;
    Namespace?: string;
    Kind: string;
    Status: KubernetesLiveResourceStatusCode;
    MachineId: string;
    LastUpdated: Moment;
    Details?: KubernetesLiveStatusManifestDetailsResource;
    Children: KubernetesLiveStatusDetailedResource[];
    DesiredResourceId?: string;
    ResourceId?: string;
};
export type KubernetesPodLiveStatusDetailedResource = Omit<BaseKubernetesLiveStatusDetailedResource, "Details"> & {
    Kind: "Pod";
    Details: KubernetesLiveStatusPodManifestDetailsResource;
};
export type KubernetesLiveStatusDetailedResource = BaseKubernetesLiveStatusDetailedResource | KubernetesPodLiveStatusDetailedResource;
export type KubernetesLiveStatusManifestDetailsResource = {
    Labels: Record<string, string>;
    Annotations: Record<string, string>;
    CreationTimestamp: Moment;
};
export type KubernetesLiveStatusPodManifestDetailsResource = KubernetesLiveStatusManifestDetailsResource & {
    Containers: string[];
};
export type GetLiveResourceResponse = {
    Resource: KubernetesLiveStatusDetailedResource;
};
export function isPodResource(resource: BaseKubernetesLiveStatusDetailedResource | undefined): resource is KubernetesPodLiveStatusDetailedResource {
    return resource?.Kind === "Pod";
}
